import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'Components/Atoms/Box';
import Typography from 'Components/Atoms/Typography';
import { BookingWindowStatus, formatBookingWindowDate } from 'types/shared/helper/bookingWindow';

/**
 * Staff may book outside the guests' booking window; this says so before the
 * reservation is saved.
 */
const BookingWindowNotice = ({ bookingWindow }: { bookingWindow: BookingWindowStatus | null }) => {
  const { t, i18n } = useTranslation('reservations');

  if (!bookingWindow || bookingWindow.released) return null;

  const text =
    bookingWindow.mode === 'invalid'
      ? t('The online booking window is misconfigured, guests cannot book online right now. You can still book internally.')
      : t('This date is not released for guests (online bookings up to and including {{date}}). You are booking internally outside the booking window.', {
          date: formatBookingWindowDate(bookingWindow.lastBookableDate ?? '', i18n.language ?? 'de'),
        });

  return (
    <Box
      role="status"
      style={{
        border: '1px solid var(--color-warning)',
        borderRadius: 4,
        padding: '8px 12px',
        marginTop: 8,
      }}
    >
      <Typography variant="text-3" translation={null}>
        {text}
      </Typography>
    </Box>
  );
};

export default BookingWindowNotice;
